import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import AddDocumentTypeToPermitTypeForm, { FormData } from "./AddDocumentTypeToPermitTypeForm";
import { FormError } from "../models/FormError";
import { DocumentType } from "../models/DocumentType";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (selectedDocumentTypeIds: string[]) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  availableDocumentTypes: DocumentType[];
}

const AddDocumentTypeToPermitTypeModal = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  availableDocumentTypes,
}: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);
  const [formErrors, setFormErrors] = useState<FormError>({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setFormData({} as FormData);
    setFormErrors({} as FormError);
    setHasSubmitted(false);
  }, [open]);

  const validateFormData = (data: FormData): FormError => {
    const formError: FormError = {};

    if (!data.documentTypeIds || data.documentTypeIds.length < 1) {
      formError.documentTypeIds = "Please select at least one document type";
    }

    return formError;
  };

  const handleSubmit = () => {
    setHasSubmitted(true);

    const validationErrors = validateFormData(formData);
    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      onSubmit(formData.documentTypeIds);
    }
  };

  const handleFormChange = (data: FormData) => {
    if (hasSubmitted) {
      setFormErrors(validateFormData(data));
    }

    setFormData({ ...data });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} size="small">
      <Modal.Header>Add document types to permit type</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <AddDocumentTypeToPermitTypeForm
            formData={formData}
            formErrors={formErrors}
            errors={submitErrors}
            onChange={handleFormChange}
            availableDocumentTypes={availableDocumentTypes}
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddDocumentTypeToPermitTypeModal;
